export default __webpack_public_path__ + "static/media/aluno.08f96042.jpeg";